var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"container"}},[_c('div',{staticClass:"msection-wrap"},[_c('main-banner'),_c('main-realtime-dibs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }